<template>
  <div id="warp_sim12">
    <div class="content" style="padding:1rem 0;">
        <div style="position: relative; left: -1.7rem">
          <a-form-model
            ref="ruleForm"
            :model="form"
            labelAlign="right"
            layout="inline"
            hideRequiredMark
            :rules="rules"
          >
            <a-row>
              <a-col :span="12" class="asas">
                <a-form-model-item prop="securitiesAccount" ref="securitiesAccount" label="證券帳號">
                  <a-input
                    v-model="form.securitiesAccount"
                    placeholder="請輸入證券帳號"
                    auto-complete="new-accounts"
										:disabled="true"
                    :maxLength="7"
                     @change="
                      form.securitiesAccount = form.securitiesAccount.replace(/[^0-9]+/g, '')
                    "
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item  label="帳戶狀態">

                  <a-select
                    v-if="form.accountStatus != '註銷' && customerInfoImport"
                    v-model="form.accountStatus"
                    placeholder="請選擇帳戶狀態"
                  >
                    <a-select-option v-for='(item , ind) in options1' :value="item.value" :key='ind'>
                      {{item.value}}
                    </a-select-option>
                  </a-select>
                  <a-input v-else v-model="form.accountStatus" class="acco_class" disabled/>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item prop="chineseName" label="中文名稱">
                  <a-input
                    v-model="form.chineseName"
                    :disabled="!userfileAuditAdmin"
                    placeholder="請輸入中文名稱"
                    onkeyup="value=value.replace(/[^\u4e00-\u9fa5]/g,'')"/>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="englishName" label="英文名稱">
                  <a-input
                    v-model="form.englishName"
                    :disabled="!userfileAuditAdmin"
                    placeholder="請輸入英文名稱"
                    onkeyup="value=value.replace(/[^a-z A-Z]/g,'')" />
                </a-form-model-item>
              </a-col>

            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item prop="phoneNumber" label="電話號碼" class="phoneSty">
                  <a-input
                    v-model="form.phoneNumber"
                    :disabled="!userfileAuditAdmin"
                     @change="
                      form.phoneNumber = form.phoneNumber.replace(/[^0-9]+/g, '')
                    "
                    auto-complete="new-password"
                    :maxLength="form.notai == '852' ? '8' : '11'"
                    placeholder="請輸入電話號碼"
                  >
                  <div style="margin-right: 0.5rem;position: relative;width: 80px;"  slot="prefix">
                    <a-select
                      style="width: 100%;"
                      id="warp_input"
                       @change="qhclick"
                      :disabled="!userfileAuditAdmin"
                      v-model="form.notai"
                      :getPopupContainer="
                        (triggerNode) => {
                          return triggerNode.parentNode;
                        }
                      "
                      >>
                      <a-select-option
                        v-for="item in qhArr"
                        :key="item.id"
                        :label="item.value"
                        :value="item.value"
                      >
                        <span style="font-size: 16px; float: left" v-if="item.id!=12">+{{ item.value }}</span>
                        <span style="font-size: 16px; float: left" v-else>{{ item.label }}</span>
                      </a-select-option>
                    </a-select>
                    <div style="position: absolute;color: #606266;top: 3px;left:1px;height: 80%;display: flex;align-items: center;justify-content: center;
                          width: 70%;background: #fff;border-radius: 4px;">
                      <div v-if="!qhflag">+{{form.notai}}</div>
                      <div class="qh_input" v-else style="display: flex;align-items: center;justify-content: center;">
                        <div style="margin-left: 10px;font-size: 16px;">+</div>
                        <a-input onkeyup="value=value=value.replace(/[^\d]/g,'')" :maxLength="3" v-model="form.notai" wi/>
                      </div>
                    </div>
                  </div>
                  </a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="emailAddress" label="電郵地址">
                  <a-input
                    :disabled="!userfileAuditAdmin"
                    v-model="form.emailAddress"
                    placeholder="請輸入電郵地址"
                    @blur='emailfn(form.emailAddress)'
                  />
                </a-form-model-item>
              </a-col>


            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item prop='birth' label="出生日期">
									<a-date-picker v-model="form.birth" :disabled-date="disabledDate"  class='warp_width' :disabled="form.khuser_flag == 1" placeholder='出生日期' />
								</a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="identityInformation" label="身份信息">
                  <a-input
                    :disabled="!userfileAuditAdmin"
                    v-model="form.identityInformation"
                    placeholder="請輸入身份信息"
                    :maxLength="21"
                    @change="
                    form.identityInformation = form.identityInformation.replace(/[^a-zA-Z0-9]+/g, '')
                  "
                  />
                </a-form-model-item>
              </a-col>


            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item prop="bankName" label="銀行名稱">
                  <a-input
                    :disabled="!userfileAuditAdmin"
                    v-model="form.bankName"
                    placeholder="請輸入銀行名稱"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="bankNumber" label="銀行號碼">
                  <a-input
                    :disabled="!userfileAuditAdmin"
                    v-model="form.bankNumber"
                    onkeyup="value=value.replace(/[^\d]/g,'') "
                    placeholder="請輸入銀行號碼"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
              <a-col :span="12">
                <a-form-model-item prop="nationality_en" label="國籍(英文)">
                  <a-input
                    v-model="form.nationality_en"
                    :disabled="!userfileAuditAdmin"
                    placeholder="請輸入英文國籍"
                    onkeyup="value=value.replace(/[^a-z A-Z]/g,'')" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="residential_nationality_cn" label="居住國家">
                
									<Situationall v-model="form.residential_nationality_cn"
										:url='$api.getCustomerCountryOfResidence'
										:disabled='!userfileAuditAdmin'
										:valonce='form.residential_nationality_cn'
										:params='{"type":"residential_nationality_cn"}'
										:style='"width: 100%;"'>
									</Situationall>
                  
                </a-form-model-item>
              </a-col>
            </a-row>

            <a-row>
              <a-col :span="12">
                <a-form-model-item prop="risk_type" label="風險評級">
                  <a-select
                    v-model="form.risk_type"
                    placeholder="請選擇風險評級"
                  >
                    <a-select-option v-for='(item , ind) in options2' :value="item.value" :key='ind'>
                      {{item.label}}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item prop="rating_date" label="評級日期">
                  <a-date-picker v-model="form.rating_date"  class='warp_width'  placeholder='評級日期' />
                </a-form-model-item>
              </a-col>
            </a-row>

            <!-- <a-row>
              <a-col :span="12">
                <a-form-model-item label="簽署文件">
                  <div class="sign_class" @click="signClick()" :style="{borderColor : signFlag ? '#0c8b97' :'#d9d9d9'}">
                    <span>查看簽署文件</span>
                    <img src="../../../../image/sign.png" style="margin-left:auto">

                    <div class="sign_pop" v-if="signFlag">
                      <div class="sign_pop_class">
                        <span>W-8BEN</span>
                        <span class="sign_pop_margin" :style="{color : dataAll.w8benStatus == '未簽署' ||  dataAll.w8benStatus == '已過期'? '#ed4849' : '#3bc7a1'}">{{dataAll.w8benStatus}}</span>
                      </div>
                      <div class="sign_pop_class">
                        <span>OTC</span>
                        <span class="sign_pop_margin" :style="{color : dataAll.otcStatus == '未簽署' ||  dataAll.otcStatus == '已過期'? '#ed4849' : '#3bc7a1'}">{{dataAll.otcStatus }}</span>
                      </div>
                      <div class="sign_pop_class">
                        <span>HKIDR</span>
                        <span class="sign_pop_margin" :style="{color : dataAll.hkidrStatus == '未簽署' ||  dataAll.hkidrStatus == '已過期'? '#ed4849' : '#3bc7a1'}">{{dataAll.hkidrStatus}}</span>
                      </div>
                      <div class="sign_pop_class">
                        <span>RPQ</span>
                        <span class="sign_pop_margin" :style="{color : dataAll.rpqStatus == '未簽署' ||  dataAll.rpqStatus == '已過期'? '#ed4849' : '#3bc7a1'}">{{dataAll.rpqStatus}}</span>
                      </div>
                      <div class="sign_pop_class">
                        <span>IOQ</span>
                        <span class="sign_pop_margin" :style="{color : dataAll.ioqStatus == '未簽署' ||  dataAll.ioqStatus == '已過期'? '#ed4849' : '#3bc7a1'}">{{dataAll.ioqStatus}}</span>
                      </div>
                    </div>
                  </div>
                </a-form-model-item>
              </a-col>

              <a-col :span="12" class="radio_cla">
                <a-form-model-item prop="entrust_flag" label="全權委託">
                  <a-radio-group v-model="form.entrust_flag" >
                      <a-radio :value="1">是</a-radio>
                      <a-radio :value="2">否</a-radio>
                  </a-radio-group>
                </a-form-model-item>
              </a-col>
            </a-row> -->

            <a-row>
              <a-col style=" text-align: center;">
                <a-form-model-item
                  prop="addressInformation"
                  label="地址信息"
                  class="address"
                  style="position: relative;"
                >
                  <a-input
                    v-model="form.addressInformation"
                    :disabled="!userfileAuditAdmin"
                    placeholder="請輸入地址信息"
                  />
                  <img :src="require('../../../../image/dzck.png')"  style="position: absolute;right: 10px;top: 2px;width: 1em;" @click="setVisible = true" v-if="dataAll.addresspicurl">
                  <handItem v-if='setVisible' @child='handfn' :record='dataAll.addresspicurl'></handItem>
                </a-form-model-item>
                <!-- <span>地址信息: &nbsp;</span>
                <a-input
                  v-model="form.addressInformation"
                  placeholder="請輸入地址信息"
                  style="width:85%"
                /> -->
              </a-col>
            </a-row>
            <a-row>
              <a-col style=" text-align: center;">
                <a-form-model-item
                  prop="address_en"
                  label="英文地址"
                  class="address"
                  style="position: relative;"
                >
                  <a-input
                    v-model="form.address_en"
                    :disabled="!userfileAuditAdmin"
                    placeholder="請輸入英文地址"
                    :maxLength="130"
                    onkeyup="value=value.replace(/[\u4E00-\u9FA5]/g,'')"
                  />
                </a-form-model-item>
                <!-- <span>地址信息: &nbsp;</span>
                <a-input
                  v-model="form.addressInformation"
                  placeholder="請輸入地址信息"
                  style="width:85%"
                /> -->
              </a-col>
            </a-row>

          </a-form-model>
        </div>
      </div>
			<div style="text-align: right;border-top: 1px solid #e5e5e5;padding: 2rem 0;" v-if="userfileAuditAdmin || customerInfoImport">
				<button
					class="btn1 btnx"
					@click="handleCancel(1)"
					v-html="'提&emsp;&emsp;交'"
				></button>
			</div>
  </div>
</template>

<script>
import handItem from './handItem1'
import App from "@/assets/app.js";
export default {
  props: ["items"],
  components: {
    handItem,
  },
  // components:{handhome1,handhome2,handhome3,handhome4,handhome5},
  data() {
    return {
      qhflag:false,
      signFlag:false,
      options:[
        {value:'正常'}, 
        {value:'暫停'},
        {value:'不動'},
        {value:'註銷'}
      ],
      options1:[
        {value:'正常'}, 
        {value:'暫停'},
        {value:'不動'},
        {value:'註銷'}
      ],
      options2:[
        {value:1,label: "保守型"}, 
        {value:2,label: "穩健型"},
        {value:3,label: "均衡型"},
        {value:4,label: "增長型"},
        {value:5,label: "進取型"}
      ],
      dataAll:{},
      setVisible:false,
      customerInfoImport: this.$store.state.rolesdata.indexOf("customerInfoImport") >= 0,
      userfileAuditAdmin: this.$store.state.rolesdata.indexOf("userfileAuditAdmin") >= 0,
			form: {
        entrust_flag:2,
        risk_type: "",
        rating_date: "",
        birth: null,
        khuser_flag: null,
        securitiesAccount: "",
        accountStatus: "",
        chineseName: "",
        englishName: "",
        phoneNumber: "",
        notai: "",
        emailAddress: "",
        identityInformation: "",
        bankName: "",
        bankNumber: "",
        addressInformation: "",
        nationality_en: "",
        address_en: "",
        residential_nationality_cn: "",
      },
			rules: {
        securitiesAccount: [{ required: true, message: "" }],
        chineseName: [{ required: true, message: "" }],
        englishName: [{ required: true, message: "" }],
        phoneNumber: [{ required: true, message: "" }],
        emailAddress: [{ required: true, message: "" }],
        nationality_en: [{ required: true, message: "" }],
        identityInformation: [{ required: true, message: "" }],
        birth: [{required: true,message: ' ',trigger: 'change'}],
        residential_nationality_cn: [{ required: true, message: "" }],
      },
			      // 手機區號列表
      qhArr: [
        {
          id: "1",
          value: "86",
          label: "中國",
        },
        {
          id: "2",
          value: "852",
          label: "中國香港",
        },
        {
          id: "3",
          value: "853",
          label: "中國澳門",
        },
        {
          id: "11",
          value: "886",
          label: "中國台灣",
        },
        {
          id: "4",
          value: "61",
          label: "澳大利亞",
        },
        // {
        // 	id: '5',
        // 	value: '1',
        // 	label: '加拿大'
        // },
        {
          id: "6",
          value: "60",
          label: "馬來西亞",
        },
        {
          id: "7",
          value: "1",
          label: "美國",
        },
        {
          id: "8",
          value: "65",
          label: "新加坡",
        },
        {
          id: "9",
          value: "64",
          label: "新西蘭",
        },
        {
          id: "10",
          value: "44",
          label: "英國",
        },
        {
          id: "12",
          value: "",
          label: "其他",
        },
      ],
    };
  },
  mounted() {
    this.echoData()
		// this.form.securitiesAccount = this.items.username;
    // this.form.chineseName = this.items.cn_name;
    // this.form.englishName = this.items.en_name;
    // this.form.phoneNumber = this.items.phonenum;
    // this.form.notai = this.items.nationcode!=undefined? this.items.nationcode : this.form.notai;
    // this.form.emailAddress = this.items.email;
    // this.form.identityInformation = this.items.id_number;
    // this.form.bankName = this.items.bank;
    // this.form.bankNumber = this.items.bank_number;
    // this.form.addressInformation = this.items.address;
  },

  methods: {
    qhclick(val){
      if(!val){
        this.qhflag = true
      }else{
        this.qhflag = false
      }
    },
    signClick(){
      this.signFlag = !this.signFlag
    },
    disabledDate(current) {
      var now = '1918-01-01';
      var nows = '2005-01-01'
      var moment = this.$moment(now,'YYYY-MM-DD');
      var moments = this.$moment(nows,'YYYY-MM-DD');
      return current < moment || current > this.$moment().endOf("day");
      // return current < moment || current > moments;
    },
    emailfn(ind) {
      console.log(ind);
      var t = /^[A-Za-zd0-9]+([-_.][A-Za-zd]+)*@([A-Za-zd]+[-.])+[A-Za-zd]{2,5}$/;

      // if (this.moreFzOption[ind].value) {
        if (!(t.test(ind))) {
          this.form.emailAddress = ''
          // this.$message.warning('請輸入正確的電郵地址')
        }
      // }
    },
    formatDatefn(date, ste) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      if (ste) {
        return y + '/' + m
      } else {
        return y + '-' + m + '-' + d;
      }
    },
   
		handleCancel() {
			this.$refs.ruleForm.validate((valid) => {
				if(valid){
          this.$confirm("是否確認修改此數據", "是否修改？", {
						confirmButtonText: "確認",
						cancelButtonText: "取消",
						confirmButtonClass: "confirmbtn",//自定义class
						type: "warning"
					}).then(() => {

            if (this.form.notai) {
              this.form.notai = this.form.notai.replace(/\+/g, '')
            }
            this.$ajax({
              method: "post",
              url: this.$api.editQmisUserMsgFilePage,
              data: {
                birth: this.formatDatefn(new Date(this.form.birth)),
                username: this.form.securitiesAccount,
                cn_name: this.form.chineseName,
                en_name: this.form.englishName,
                nationcode: this.form.notai,
                phonenum: this.form.phoneNumber,
                email: this.form.emailAddress,
                id_number: this.form.identityInformation,
                bank: this.form.bankName,
                bank_number: this.form.bankNumber,
                address: this.form.addressInformation,
                address_en: this.form.address_en,
                nationality_en: this.form.nationality_en,
                residential_nationality_cn: this.form.residential_nationality_cn,
                accountStatus: this.form.accountStatus,
                entrust_flag: this.form.entrust_flag,
                rating_date: this.formatDatefn(new Date(this.form.rating_date)),
                risk_type: this.form.risk_type,
                flag: this.flag,
              },
            }).then((res) => {
              if (res.data.qmiscode == 1000) {
                App.oTool.successT();
                this.$emit('child');
                // this.$router.go(0)
              } else {
                App.oTool.warningT(res.data.qmismsg);
              }
            });
          }).catch(() => {
          })
				}
			})
    },
    handfn(){
      this.setVisible = false
    },

    echoData(){
      this.$ajax({
        method: "post",
        url: this.$api.getQmisUserMsgWithUsername,
        data: {
          username:this.items.username,
        },
      }).then((res) => {
        if (res.data.qmiscode == 1000) {
          this.dataAll = res.data;
          this.form.risk_type = res.data.risk_type;
          this.form.rating_date = res.data.rating_date;
          this.form.entrust_flag = res.data.entrust_flag;
          this.form.securitiesAccount = res.data.username;
          this.form.chineseName = res.data.cn_name;
          this.form.englishName = res.data.en_name;
          this.form.accountStatus = res.data.accountStatus;
        
          this.form.emailAddress = res.data.email;
          this.form.identityInformation = res.data.id_number;
          this.form.bankName = res.data.bank;
          this.form.bankNumber = res.data.bank_number;
          this.form.addressInformation = res.data.address;
          this.form.birth = res.data.birth;
          this.form.address_en = res.data.address_en;
          this.form.nationality_en = res.data.nationality_en;
          this.form.khuser_flag = res.data.khuser_flag;
          this.form.residential_nationality_cn = res.data.residential_nationality_cn;
          // this.filetype = this.dataAll.way
          if (!res.data.nationcode) {
              res.data.phonenum =  '+' + res.data.phonenum.replace(/\+/g, '')
          }
          const firstThreeDigits = res.data.phonenum.substring(0, 4) == '+852';
          const firstThreeDigits1 = res.data.phonenum.substring(0, 4) == '+853';
          const firstThreeDigits3 = res.data.phonenum.substring(0, 4) == '+886';
          const firstThreeDigits2 = res.data.phonenum.substring(0, 2) == '+1';
          if(res.data.nationcode){
            this.form.phoneNumber = res.data.phonenum;
            this.form.notai = res.data.nationcode!=undefined? res.data.nationcode : this.form.notai;
          }else{
            if (firstThreeDigits || firstThreeDigits1 || firstThreeDigits3) {
              this.form.notai = res.data.phonenum.slice(1, 4)
              this.form.phoneNumber = res.data.phonenum.slice(4)
            }else if (firstThreeDigits2) {
              this.form.notai = res.data.phonenum.slice(1, 2)
              this.form.phoneNumber = res.data.phonenum.slice(2)
            }else{
              this.form.notai = res.data.phonenum.slice(1, 3)
              this.form.phoneNumber = res.data.phonenum.slice(3)
            }
          }
          // this.form.phoneNumber = res.data.phonenum;
          // this.form.notai = res.data.nationcode!=undefined? res.data.nationcode : this.form.notai;
        } else {
          App.oTool.warningT(res.data.qmismsg);
        }
      });
    },


  },
};
</script>
<style >
  .qh_input .ant-input{
    border: none !important;
    height: 95% !important;
    box-shadow: none !important;
    padding: 0 !important;
    padding-left: 0 !important;
  }
  .qh_input .ant-input-affix-wrapper .ant-input:not(:first-child){
    padding-left: 0 !important;
  }
  @media screen and (min-width:2200px){
    .phoneSty .ant-input-affix-wrapper .ant-input-prefix {
      left: 2px !important;
      top: 33px !important;

    }
  }
  .acco_class{
    background: #f5f5f5;
    color: rgba(0,0,0,.25) !important;
  }
  #warp_sim12 .radio_cla  .ant-form-item-control{
    width: 50% !important;
  }


</style>

<style lang="scss" scoped>

.sign_class{
  width: 100%;
  height: 1.75rem;
  border: 1px solid #d9d9d9;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  padding: 0 11px;
  border-radius:4px;
  position: relative;
}
.sign_pop{
  position: absolute;
  width: 100%;
  left: 0;
  top: 2rem;
  z-index: 9;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  font-size: 0.75rem;
  padding: 5px 12px;
}
.sign_pop_class{
  display: flex
  
}
.sign_pop_margin{
  margin-left: auto;
  font-weight: 600;
}

.phoneSty .ant-select-arrow {
  right: 6px !important;
}
.phoneSty .ant-input-affix-wrapper .ant-input:not(:first-child) {
  padding-left: 35%;
}
.phoneSty .ant-input-affix-wrapper .ant-input-prefix {
  left: 2px !important;
  top: 18px;

}

.phoneSty .ant-input-affix-wrapper .ant-input-prefix :not(.anticon),
.ant-input-affix-wrapper .ant-input-suffix :not(.anticon) {
  line-height: 25.5px !important;
}
.phoneSty .ant-select-selection {
  border: 0 !important;
  height: 25px;
}
.phoneSty .ant-select-focused .ant-select-selection,
.ant-select-selection:active,
.ant-select-selection:focus {
  border: 0 !important;
  box-shadow: none !important;
}


.address .ant-form-item-control-wrapper {
  width: 85% !important;
}
.content {
  padding-bottom: 1rem;
  border-radius: 0 0 10px 10px;
  padding: 1rem;
  background-color: #fff;
  width: 100%;
  margin: 0 auto;
  min-height: 50px;
}
#warp_sim12 .ant-modal-header,
#warp_sim12 .ant-modal-body {
  background-color: #e5e5e5 !important;
  padding: 1rem;
  padding-top: 0.7rem;
}

.mark-file {
  position: absolute;
  top: 0;
  left: 0;

  div {
    width: 6rem;
    font-size: 1rem;
    padding: 0.5rem 1rem;
    display: inline-block;
  }
}

#warp_sim12 {
  .ant-radio-wrapper {
    display: flex;
    align-items: center;
  }
  .ant-form-explain {
    display: none;
  }

  .ant-modal {
    top: 28%;
  }

  .ant-col-12 {
    text-align: center;
  }
  .myleft {
    text-align: left;
  }
  .ant-form-item-label {
    width: 15% !important;
  }

  .ant-form-item,
  .ant-form-item-control {
    width: 100%;

    .ant-calendar-picker {
      width: 100%;
    }
  }

  .ant-radio-group-default {
    width: 100%;
    margin-top: 0.3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      font-size: 0.8rem;
    }
  }

  .ant-form-item-control-wrapper {
    width: 70%;

    .ant-form-item-control {
      width: 100%;
    }
  }

  #lastname {
    text-align: right;

    .ant-form-item-label {
      width: 10%;
    }

    .ant-form-item-control-wrapper {
      width: 86%;
    }
  }

  .ant-form-inline .ant-form-item {
    margin-right: 0;
  }

  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-form-item {
    margin-bottom: 0.5rem;
  }

  .ant-form-item label {
    font-size: 0.8rem !important;
  }

  .ant-input {
    font-size: 0.8rem !important;
  }

  .ant-select-selection-selected-value {
    font-size: 0.8rem !important;
  }

  .ant-form-item-children {
    font-size: 0.8rem !important;
  }

  .ant-modal-body {
    padding: 0;
    padding-top: 2.5rem;
  }

  .btn1 {
    cursor: pointer;
    width: 8rem;
    height: 2rem;
    font-size: 0.8rem;
    color: #fff;
    border: 0;
    border-radius: 5px;
		margin-right: 1.7rem;
  }

  .btnx {
    background-color: #0c8b97;
  }

  .btn2 {
    background-color: #ed4849;
  }

  .mydivs {
    max-height: 7rem;
    overflow-y: auto;
    // margin-bottom: 1rem;
    padding: 1rem;
    margin-left: 4%;
    width: 96%;
    background-color: #f5f5f5;
    margin-bottom: 1rem;

    .c {
      font-size: 0.8rem;
    }

    .f {
      // text-align: right;
      display: flex;
      justify-content: space-between;
    }

    .t {
      margin: 0.5rem 0;
      border-bottom: 1px solid #d9d9d9;
    }
  }
}
</style>
